"use client";

import { useEffect, useState, type ComponentPropsWithoutRef } from "react";
import Image from "next/image";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

type EmptySequencesIllustrationProps = Omit<
  ComponentPropsWithoutRef<typeof Image>,
  "src" | "alt"
> & {
  alt?: string;
};

function useEmptySequencesIllustrationSrc() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return "/illustrations/sequences-empty.svg";
  }

  return resolvedTheme === "light"
    ? "/assets/light/sequences-empty.svg"
    : "/illustrations/sequences-empty.svg";
}

export function EmptySequencesIllustration({
  className,
  alt = "",
  width = 215,
  height = 140,
  ...props
}: EmptySequencesIllustrationProps) {
  const src = useEmptySequencesIllustrationSrc();

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={cn("h-[140px] w-[215px]", className)}
      {...props}
    />
  );
}
